import type { Config } from "../core/types";
import { Logger } from "../core/Logger";

export interface IConfigClient {
    fetchConfig(widgetKey: string): Promise<Config>;
}

export class ConfigClient implements IConfigClient {
    constructor(private environment?: string) { }

    async fetchConfig(widgetKey: string): Promise<Config> {
        try {
            const url = this.environment === 'development' ? 'http://localhost:8080' : 'https://selectfi.app';
            Logger.debug(`Fetching config from ${url} for widgetKey: ${widgetKey}`);

            const response = await fetch(`${url}/wp-json/v1/widget_sdk/config/${widgetKey}`);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const data = await response.json();

            if (!data) {
                throw new Error('Failed to decode config data');
            }

            return data;

        } catch (error) {
            Logger.error(`Failed to fetch config for widgetKey: ${widgetKey}`, error);
            throw error;
        }
    }
}